import { useTranslation } from "react-i18next";
import Spraakvelger from "../components/Spraakvelger";
import Container from "../../components/Layout/Container";
import EksternLinkButton from "../../components/button/EksternLinkButton";
import { track } from "../../api/tracking";
import { useRedirectUrl } from "../../hooks/useRedirectUrl";
import Heading from "../../components/sheriff-wrappers/Heading";
import styles from "./landingsside.module.scss";
import cn from "classnames";

const Landingsside = () => {
  const { t } = useTranslation("skjematekst", { keyPrefix: "forside" });
  track.pageView("Landingsside");

  const { urlTilInnlogging } = useRedirectUrl();

  return (
    <Container addGap className={cn("sds-spacing-p-b-md", styles["pb-8"])}>
      <Heading>{t("tittel")}</Heading>
      <Spraakvelger />
      <p style={{ fontSize: "1.25rem", lineHeight: "1.75rem" }}>
        {t("beskrivelse.omAaAnmelde.infotekst.info")}
      </p>
      <EksternLinkButton
        navigateTo={urlTilInnlogging}
        buttonType="primary"
        text={t("knapper.loggInn")}
        trackingName={"Logg inn og anmeld"}
      />
    </Container>
  );
};

export default Landingsside;
